import type React from "react";
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  useTheme,
} from "@mui/material";

interface PackageItem {
  name: string;
  price: number;
}

interface PackageCardProps {
  name: string;
  price: number;
  items: PackageItem[];
  total: string | number;
}

const PackageCard: React.FC<PackageCardProps> = ({
  name,
  price,
  items,
  total,
}) => {
  const theme = useTheme();

  return (
    <Paper sx={{ p: 2, height: "100%", boxShadow: 0 }}>
      <Typography variant="h6" sx={{ fontSize: 16 }}>
        Livestream Package
      </Typography>

      <Box
        mt={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography fontWeight="bold">{name}</Typography>
        <Typography fontWeight="bold">${price}</Typography>
      </Box>

      <List>
        {items.map((item, idx) => (
          <ListItem key={idx} disableGutters>
            <ListItemText primary={`+ ${item.name}`} />
            <Typography sx={{ fontSize: 13 }}>${item.price}</Typography>
          </ListItem>
        ))}
      </List>

      <Box mt={1} textAlign="right">
        <Typography fontWeight="bold">${total}</Typography>
      </Box>
    </Paper>
  );
};

export default PackageCard;
